// frontend/src/components/SubscriptionForm.jsx
// Role: Email subscription form component with input field and subscribe button

import React, { useState } from 'react';
import './SubscriptionForm.css';

function SubscriptionForm({ onSubscribe }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setMessage('Please enter your email address');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');
    
    try {
      const result = await onSubscribe(email);
      
      if (result.success) {
        setMessage('Successfully subscribed! You will receive daily stock news.');
        setMessageType('success');
        setEmail(''); // Clear the input
      } else {
        setMessage(result.message || 'Subscription failed. Please try again.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Network error. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-form">
      <div className="subscription-header">
        <h3>📧 Subscribe to Daily Stock News</h3>
        <p>Get important stock market news delivered to your inbox daily</p>
      </div>
      
      <form onSubmit={handleSubmit} className="subscription-form-container">
        <div className="input-group">
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="email-input"
            disabled={loading}
            required
          />
          <button 
            type="submit" 
            className="subscribe-button"
            disabled={loading}
          >
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </div>
        
        {message && (
          <div className={`message ${messageType}`}>
            {message}
          </div>
        )}
      </form>
    </div>
  );
}

export default SubscriptionForm;